// extracted by mini-css-extract-plugin
export default {"tx":"_3d1b98150d","line":"b98faf3392"};